import React from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "../../../redux/store";
import useAuth from "../../../hooks/useAuth";
import { currencySymbol, DateFormat } from "../../../utils/helpers";
import { loanMsgValidator } from "../../../Validations/loanoffer/loanMsgValidator";
import { useEffect, useState } from "react";
import { useRef } from "react";
import CurrencyFormat from "react-currency-format";
import Swal from "sweetalert2";
import {
  acceptLoanOffer,
  getLoanOfferMsg,
  getMessages,
  sendLoanOffer,
  sendMessage,
} from "../../../redux/slices/loanOffers";
import "./LoanReview.css";
export default function CustomerLoanChat({
  messages,
  offerId,
  isAgreed,
  setMessages,
  conversations,
  setConversations,
}) {
  const endOfChat = useRef(null);
  const { user, isAuthenticated } = useAuth();
  const dispatch = useDispatch();
  const [sendOffer, setSendOffer] = useState(false);
  const [isRadio, setIsRadio] = useState();

  const [inputValues, setInputValues] = useState({
    amount: 0,
    roi: 0,
    tenure: 0,
    message: "",
  });
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    // formState: { errors, isValid },
    control,
    reset,
  } = useForm({
    mode: "all",
    resolver: yupResolver(loanMsgValidator),
    defaultValues: {
      message: "",
    },
  });
  // useEffect(() => {
  // if (isSaved && loanData) {
  //   Swal.fire({
  //     icon: "success",
  //     text: `Loan application submitted successfully.`,
  //   });
  //   dispatch(resetLoading());
  //   if (loanData?.loan_id !== undefined) {
  //     navigate({
  //       pathname: "/pre-qualification-document",
  //       search: `?${createSearchParams({
  //         loanId: loanData?.loan_id,
  //       })}`,
  //     });
  //   }
  // }
  // }, []);

  const handleSubmitMsg = async (data) => {
    const { message } = data;
    const dateTimeNow = new Date();
    dispatch(sendLoanOffer({ offerId, message }))
      .unwrap()
      .then((res) => {
        if (res.success) {
          setMessages((prev) => {
            return [
              ...prev,
              {
                sent_by: user.id,
                created_at: dateTimeNow,
                offer_description: message,
                user: user,
              },
            ];
          });
        }
      });

    reset();
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputValues((prev) => {
      return { ...prev, [name]: value };
    });
  };
  const handleClickCheckbox = (e) => {
    setSendOffer((prev) => !prev);
    setInputValues((prev) => {
      return { ...prev, amount: 0, roi: 0, tenure: 0 };
    });
    reset({
      amount: 0,
      roi: 0,
      tenure: 0,
    });
  };
  const handleMessageSubmit = (data) => {
    const { message } = data;
    const dateTimeNow = new Date();
    dispatch(sendMessage({ offerId, message }))
      .unwrap()
      .then((res) => {
        if (res.success) {
          dispatch(getMessages(offerId)).then((res) => {
            if (res.success) {
              setConversations(res?.offerMessages);
            }
          });
          setInputValues({
            message: "",
          });
          // setConversations((prev) => {
          //   return [
          //     ...prev,
          //     {
          //       sent_by: user.id,
          //       created_at: dateTimeNow,
          //       offer_description: message,
          //       user: user,
          //     },
          //   ];
          // });
        }
      });

    reset();
    // const { message, tenure, roi, amount } = data;
    // let messageBody = {
    //   message,
    // };

    // if (sendOffer) {
    //   messageBody = {
    //     message,
    //     tenure,
    //     roi,
    //     amount,
    //   };
    // }
    // const chatMessage =
    //   "Amount : " +
    //   data?.amount +
    //   " " +
    //   " Message : " +
    //   data.message +
    //   " " +
    //   "Rate of Interest : " +
    //   data?.roi +
    //   " " +
    //   "Tenure : " +
    //   data?.tenure;
    // const dateNow = new Date();
    // dispatch(sendLoanOffer({ offerId, message: messageBody, sendOffer }))
    //   .unwrap()
    //   .then((res) => {
    //     if (res.success) {
    //       dispatch(
    //         getLoanOfferMsg(messages[messages.length - 1]?.loan_offer_id)
    //       )
    //         .unwrap()
    //         .then((res) => {
    //           if (res?.success) {
    //             setMessages(res?.offerMsgs);
    //           }
    //         });
    //       setInputValues({
    //         amount: 0,
    //         roi: 0,
    //         tenure: 0,
    //         message: "",
    //       });
    //       setSendOffer(false);
    //       // setMessages((prev) => [
    //       //   ...prev,
    //       //   {
    //       //     sent_by: user.id,
    //       //     created_at: dateNow,
    //       //     offer_description: message,
    //       //     roi,
    //       //     tenure,
    //       //     amount,
    //       //   },
    //       // ]);
    //       reset();
    //     }
    //   });
    // setInputValues({
    //   amount: 0,
    //   roi: 0,
    //   tenure: 0,
    //   message: "",
    // });
    endOfChat.current?.scrollIntoView({ behavior: "smooth" });
  };

  console.log("--conversations---", conversations);
  useEffect(() => {
    endOfChat.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleAgree = () => {
    if (
      window.confirm(
        "Once you agreed then you will not be able to negotiate again. Are you agree with Financer offer ?"
      )
    ) {
      let data = {
        amount: messages[messages.length - 1]?.amount,
        roi: messages[messages.length - 1]?.roi,
        tenure: messages[messages.length - 1]?.tenure,
        message: messages[messages.length - 1]?.offer_description,
      };
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          // cancelButton: "btn btn-danger mx-3",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Loan offer",
          // showCancelButton: true,
          // cancelButtonColor: "#d33",
          html: `
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td>Amount:</td>
              <td>${data.amount}</td>
            </tr>
            <tr>
              <td>ROI:</td>
              <td>${data.roi}%</td>
            </tr>
            <tr>
            <td>Tenure:</td>
            <td>${data.tenure}</td>
          </tr>
          <tr>
              <td>Message:</td>
              <td>${data.message}</td>
              
            </tr>
          </tbody>
        </table>`,
        })
        .then(() => {
          dispatch(
            acceptLoanOffer({
              id: messages[messages.length - 1]?.id,
              loan_id: messages[messages.length - 1]?.loan_id,
              loan_offer_id: messages[messages.length - 1]?.loan_offer_id,
              amount: messages[messages.length - 1]?.amount,
              roi: messages[messages.length - 1]?.roi,
              tenure: messages[messages.length - 1]?.tenure,
              message: messages[messages.length - 1]?.offer_description,
            })
          );
        });

      // dispatch(
      //   acceptLoanOffer({
      //     id: messages[messages.length - 1]?.id,
      //     loan_id: messages[messages.length - 1]?.loan_id,
      //     loan_offer_id: messages[messages.length - 1]?.loan_offer_id,
      //     amount: messages[messages.length - 1]?.amount,
      //     roi: messages[messages.length - 1]?.roi,
      //     tenure: messages[messages.length - 1]?.tenure,
      //     message: messages[messages.length - 1]?.offer_description,
      //   })
      // );
      // .unwrap()
      // .then(async (res) => {
      // setInputValues({
      //   amount: messages[messages.length - 1]?.amount,
      //   roi: messages[messages.length - 1]?.roi,
      //   tenure: messages[messages.length - 1]?.tenure,
      //   message: messages[messages.length - 1]?.offer_description,
      // });
      // console.log({ res });
      // let postData = {
      //   amount: messages[messages.length - 1].amount,
      //   roi: messages[messages.length - 1].roi,
      //   tenure: messages[messages.length - 1].tenure,
      //   message: messages[messages.length - 1].message,
      // };
      // const response = axiosInstance
      //   .post("/new-counter-offer", { ...postData })
      //   .then((response) => {
      //     console.log({ response });
      //   });
      // Swal.fire({
      //   icon: "success",
      //   text: "Customer offer accepted successfully!",
      // });
      // refreshSupplierQuote();
      // });
    }
  };

  const handleChange = (e) => {
    // string passed in
    // a string returned by default
    console.log(e.currentTarget.value);
    // add + to the event to make the value a number
    setIsRadio(+e.currentTarget.value);
  };

  const handleSubmitOffer = (e) => {
    e.preventDefault();

    if (isRadio) {
      if (
        window.confirm(
          "Once selected it cannot be changed, Do you want to confirm?"
        )
      ) {
        dispatch(
          acceptLoanOffer({
            id: isRadio,
            loan_id: messages[messages.length - 1]?.loan_id,
            loan_offer_id: messages[messages.length - 1]?.loan_offer_id,
            // amount: messages[messages.length - 1]?.amount,
            // roi: messages[messages.length - 1]?.roi,
            // tenure: messages[messages.length - 1]?.tenure,
            // message: messages[messages.length - 1]?.offer_description,
          })
        );
      }
    }
    // dispatch()
  };
  const handlePaste = (event) => {
    const clipboardData = event.clipboardData || window.clipboardData;
    const pastedText = clipboardData.getData("text");

    if (pastedText.includes("e")) {
      event.preventDefault();
    }
  };

  // useEffect(() => {
  //   dispatch(getMessages(offerId))
  //     .unwrap()
  //     .then((res) => {
  //       if (res.success) {
  //         setConversations(res?.offerMessages);
  //       }
  //     });
  // }, []);

  return (
    <main className="content mt-2">
      <div className="card">
        <div className="row">
          <div className="row col-12 col-lg-12 col-xl-12">
            <div className="col-6 position-relative">
              <div className="chat-messages p-5">
                {/* <div className="chat-message-right pb-4">
                  <div>
                    <img
                      src="https://bootdey.com/img/Content/avatar/avatar1.png"
                      className="rounded-circle mr-1"
                      alt="Chris Wood"
                      width="40"
                      height="40"
                    />
                    <div className="text-muted small text-nowrap mt-2">
                      2:33 am
                    </div>
                  </div>
                  <div className="flex-shrink-1 bg-light rounded py-2 px-3 mr-3">
                    <div className="font-weight-bold mb-1">You</div>
                    Lorem ipsum dolor sit amet, vis erat denique in, dicunt
                    prodesset te vix.
                  </div>
                </div>

                <div className="chat-message-left pb-4">
                  <div>
                    <img
                      src="https://bootdey.com/img/Content/avatar/avatar3.png"
                      className="rounded-circle mr-1"
                      alt="Sharon Lessman"
                      width="40"
                      height="40"
                    />
                    <div className="text-muted small text-nowrap mt-2">
                      2:34 am
                    </div>
                  </div>
                  <div className="flex-shrink-1 bg-light rounded py-2 px-3 ml-3">
                    <div className="font-weight-bold mb-1">Sharon Lessman</div>
                    Sit meis deleniti eu, pri vidit meliore docendi ut, an eum
                    erat animal commodo.
                  </div>
                </div> */}
                {conversations?.length > 0 &&
                  user !== null &&
                  conversations?.map((msg, idx) => (
                    <div
                      key={idx}
                      className={
                        user?.id === msg?.sent_by
                          ? " chat-message-right pb-4 mr-5"
                          : " chat-message-left pb-4 mr-5"
                      }
                    >
                      <div>
                        {msg?.user?.profile_picture !== undefined ? (
                          <img
                            src={msg?.user?.profile_picture}
                            className="rounded-circle mr-1"
                            alt="Sharon Lessman"
                            width="40"
                            height="40"
                            style={{ objectFit: "contain" }}
                          />
                        ) : (
                          <img
                            src="https://bootdey.com/img/Content/avatar/avatar3.png"
                            className="rounded-circle mr-1"
                            alt="Sharon Lessman"
                            width="40"
                            height="40"
                            style={{ objectFit: "contain" }}
                          />
                        )}

                        <div className="text-muted small text-nowrap mt-2">
                          {}
                        </div>
                      </div>
                      <div
                        className="flex-shrink-1 bg-light rounded py-2 px-3 ml-3 ml-5"
                        style={{ width: "25rem" }}
                      >
                        <div className="font-weight-bold sm mb-1">
                          {user?.id === msg?.sent_by
                            ? "You"
                            : msg?.user?.first_name +
                              " " +
                              (msg?.user?.last_name !== null &&
                                msg?.user?.last_name !== undefined &&
                                msg?.user?.last_name !== "")
                            ? msg?.user?.last_name
                            : ""}
                          {msg?.is_sanctioned === true ? (
                            <span className="badge rounded-pill bg-success mx-1">
                              Sanctioned
                            </span>
                          ) : null}
                          {msg?.user_accepted === 1 ||
                          msg?.user_accepted === true ? (
                            <span className="badge rounded-pill bg-success mx-1">
                              You Agreed
                            </span>
                          ) : (
                            ""
                          )}
                          {msg?.financer_accepted === 1 ||
                          msg?.financer_accepted === true ? (
                            <span className="badge rounded-pill bg-success mx-1">
                              Financer Agreed
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        {/* MEssage */}
                        {msg?.message !== null &&
                          msg?.message !== undefined &&
                          msg?.message !== "" && (
                            <>
                              Message:{" "}
                              <span className="counter_chat_price">
                                <span className="price-symbol">
                                  {msg?.message}
                                </span>
                              </span>
                              <br />
                            </>
                          )}
                        <br />
                        <span style={{ fontSize: "0.7rem", color: "grey" }}>
                          {<DateFormat datestring={msg?.created_at} />}
                        </span>
                      </div>
                    </div>
                  ))}
                <div ref={endOfChat}></div>
              </div>
            </div>
            <div className="col-6 ">
              <div className="chat-messages  align-items-center">
                {messages?.length > 0 &&
                  messages
                    ?.filter((item) => item.amount && item.tenure && item.roi)
                    .map((msg, idx) => {
                      return (
                        <label className="radioStyle card mt-1" key={idx}>
                          <input
                            name="plan"
                            className="radio"
                            type="radio"
                            value={msg?.id}
                            onChange={handleChange}
                            checked={
                              isRadio === msg?.id ||
                              msg?.user_accepted === 1 ||
                              msg?.user_accepted === true
                            }
                            // disabled={
                            //   msg?.user_accepted === 1 ||
                            //   msg?.user_accepted === true
                            // }
                          />

                          <span className="plan-details">
                            {msg?.amount !== null &&
                              msg?.amount !== undefined &&
                              msg?.amount !== "" &&
                              msg?.amount !== 0 && (
                                <>
                                  Amount:&nbsp;
                                  <span className="counter_chat_price">
                                    <span className="price-symbol">
                                      {currencySymbol()}
                                    </span>
                                    <CurrencyFormat
                                      value={msg?.amount}
                                      displayType={"text"}
                                      thousandSeparator={true}
                                      fixedDecimalScale={true}
                                      decimalScale={2}
                                    />
                                  </span>
                                  {msg?.user_accepted === 1 ||
                                  msg?.user_accepted === true ? (
                                    <span className="badge rounded-pill bg-success mx-1">
                                      You Agreed
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                  <br />
                                  <hr />
                                </>
                              )}
                            {/* Tenure show */}
                            {msg?.tenure !== null &&
                              msg?.tenure !== undefined &&
                              msg?.tenure !== "" &&
                              msg?.tenure !== 0 && (
                                <>
                                  Tenure:
                                  <span className="counter_chat_price">
                                    <span className="price-symbol">
                                      {msg?.tenure} Months
                                    </span>
                                  </span>
                                  <br />
                                  <hr />
                                </>
                              )}
                            {/* Rate of Intrest */}
                            {msg?.roi !== null &&
                              msg?.roi !== undefined &&
                              msg?.roi !== "" &&
                              msg?.roi !== 0 && (
                                <>
                                  Rate of Interest:
                                  <span className="counter_chat_price">
                                    <span className="price-symbol">
                                      {msg?.roi} %
                                    </span>
                                  </span>
                                  <br />
                                  <hr />
                                </>
                              )}
                            {/* Processing fees */}
                            {msg?.processing_fee !== null &&
                              msg?.processing_fee !== undefined &&
                              msg?.processing_fee !== "" &&
                              msg?.processing_fee !== 0 && (
                                <>
                                  Processing Fee:
                                  <span className="counter_chat_price">
                                    <span className="price-symbol">
                                      {msg?.processing_fee} %
                                    </span>
                                  </span>
                                  <br />
                                  <hr />
                                </>
                              )}
                          </span>
                        </label>
                      );
                    })}
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <form onSubmit={handleSubmit(handleMessageSubmit)}>
                  <div className="input-group table-responsive">
                    <table className="table table-bordered table-scroll">
                      <thead>
                        <tr>
                          <th
                            style={{ textAlign: "center" }}
                            className="text-white"
                          >
                            Send message
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <label>
                              {" "}
                              Message<span className="text-danger">*</span>
                            </label>
                            <textarea
                              {...register("message")}
                              onChange={(e) => handleInputChange(e)}
                              value={inputValues?.message}
                              name="message"
                              type={"text"}
                              rows={3}
                              className="form-control"
                              id="exampleFormControlTextarea1"
                              placeholder="Type your message here"
                            ></textarea>
                            <span className="text-danger">
                              {errors?.message?.message}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <button type="submit" className="btn btn-primary">
                      Send
                    </button>
                  </div>
                </form>
              </div>
              <div className="col-6">
                <div className="input-group table-responsive">
                  <table className="table table-bordered table-scroll">
                    <thead>
                      <tr>
                        <th
                          style={{ textAlign: "center" }}
                          className="text-white"
                        >
                          Select any one Offer
                        </th>
                      </tr>
                    </thead>
                  </table>
                </div>
                <button className="btn btn-primary" onClick={handleSubmitOffer}>
                  Send
                </button>
              </div>
            </div>
            {/* <div className="flex-grow-0 py-3 px-4 border-top"> */}
            {/* <form className="row" onSubmit={handleSubmit(handleSubmitMsg)}>
                <div className="input-group">
                  <input
                    type="text"
                    {...register("message")}
                    name="message"
                    //   value={message}
                    className={`form-control ${
                      errors.message ? "is-invalid" : ""
                    }`}
                    //   onChange={handleChange}
                    placeholder={`Type your message.`}
                  />
                  <button type="submit" className="btn btn-primary">Send</button>
                </div>
                <p className="text-danger">{errors.message?.message}</p>
              </form> */}
            {/* <form onSubmit={handleSubmit(handleMessageSubmit)}>
                <div className="flex-grow-0 py-3 px-4 border-top">
                  <div className="input-group table-responsive">
                    <table className="table table-bordered table-scroll">
                      <thead>
                        <tr>
                          <th
                            colSpan={3}
                            style={{ textAlign: "center" }}
                            className="text-white"
                          >
                            Send Offer
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colSpan={3}>
                            <div className="d-flex flex-row align-content-center justify-content-start">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={sendOffer}
                                {...register("sendOffer")}
                                value={sendOffer}
                                name="sendOffer"
                                id="sendOffer"
                                onClick={handleClickCheckbox}
                                disabled={
                                  messages[messages.length - 1]?.status ===
                                  "Accepted"
                                    ? true
                                    : false || isAgreed?.user_accepted
                                    ? true
                                    : false
                                }
                              />
                              &nbsp;
                              <label
                                htmlFor="sendOffer"
                                className="form-check-label"
                              >
                                Send Offer
                              </label>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ opacity: !sendOffer ? "0.5" : "1" }}>
                            <label>
                              Amount (in Rs.){" "}
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              {...register("amount")}
                              name="amount"
                              type={"number"}
                              className="form-control hide-arrow"
                              id="CounterPrice"
                              onPaste={handlePaste}
                              onChange={(e) => handleInputChange(e)}
                              // onPaste={(e) => {
                              //   e.preventDefault();
                              //   return false;
                              // }}
                              // onCopy={(e) => {
                              //   e.preventDefault();
                              //   return false;
                              // }}
                              min={0}
                              step={1.0}
                              onKeyDown={(evt) =>
                                ["e", "E", "+", "-"].includes(evt.key) &&
                                evt.preventDefault()
                              }
                              onWheel={(e) => e.target.blur()}
                              value={inputValues?.amount}
                              disabled={!sendOffer}
                              // defaultValue={latestPrice}
                            />
                            <span className="text-danger">
                              {errors?.amount?.message}
                            </span>
                          </td>
                          <td style={{ opacity: !sendOffer ? "0.5" : "1" }}>
                            <label>
                              ROI (in %)<span className="text-danger">*</span>
                            </label>
                            <input
                              name="roi"
                              {...register("roi")}
                              disabled={!sendOffer}
                              // type="text"
                              type={"number"}
                              // pattern="[0-9]*"
                              step="0.01"
                              min="0"
                              max="100"
                              pattern="[0-9]+"
                              className="form-control"
                              id="CounterQuantity"
                              onPaste={handlePaste}
                              // onPaste={(e) => {
                              //   e.preventDefault();
                              //   return false;
                              // }}
                              // onCopy={(e) => {
                              //   e.preventDefault();
                              //   return false;
                              // }}
                              onChange={(e) => handleInputChange(e)}
                              onKeyDown={(evt) =>
                                ["e", "E", "+", "-"].includes(evt.key) &&
                                evt.preventDefault()
                              }
                              value={inputValues?.roi}
                              onWheel={(e) => e.target.blur()}
                            />
                            <span className="text-danger">
                              {errors?.roi?.message}
                            </span>
                          </td>
                          <td style={{ opacity: !sendOffer ? "0.5" : "1" }}>
                            <label>
                              Tenure (in Months)
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              {...register("tenure")}
                              name="tenure"
                              // type="text"
                              type={"number"}
                              disabled={!sendOffer}
                              // pattern="[0-9]*"
                              // min="0"
                              // pattern="[0-9]+"
                              className="form-control"
                              id="CounterQuantity"
                              onPaste={handlePaste}
                              // min={0}
                              // onPaste={(e) => {
                              //   e.preventDefault();
                              //   return false;
                              // }}
                              // onCopy={(e) => {
                              //   e.preventDefault();
                              //   return false;
                              // }}
                              onChange={(e) => handleInputChange(e)}
                              onKeyDown={(evt) =>
                                ["e", "E", "+", "-"].includes(evt.key) &&
                                evt.preventDefault()
                              }
                              value={inputValues?.tenure}
                              onWheel={(e) => e.target.blur()}
                            />
                            <span className="text-danger">
                              {errors?.tenure?.message}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={3} rowSpan={3}>
                            <label>
                              {" "}
                              Message<span className="text-danger">*</span>
                            </label>
                            <textarea
                              {...register("message")}
                              onChange={(e) => handleInputChange(e)}
                              value={inputValues?.message}
                              name="message"
                              type={"text"}
                              rows={3}
                              className="form-control"
                              id="exampleFormControlTextarea1"
                              placeholder="Type your message here"
                              disabled={
                                messages[messages.length - 1]?.status ===
                                "Accepted"
                                  ? true
                                  : false || isAgreed?.user_accepted
                                  ? true
                                  : false
                              }
                            ></textarea>
                            <span className="text-danger">
                              {errors?.message?.message}
                            </span>
                          </td>
                          {/* <td colSpan={2} rowSpan={2}>
                           
                          </td> */}
            {/* </tr>
                      </tbody>
                    </table>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={
                        messages[messages.length - 1]?.status === "Accepted"
                          ? true
                          : false || isAgreed?.user_accepted
                          ? true
                          : false ||
                            messages[messages.length - 1]?.sent_by === user?.id
                      }
                    >
                      Send
                    </button>
                    {(messages[messages.length - 1]?.financer_accepted === 1 ||
                      messages[messages.length - 1]?.financer_accepted ===
                        true ||
                      (messages[messages.length - 1]?.sent_by !== user?.id &&
                        messages.length > 0)) && (
                      <button
                        type="button"
                        className="btn btn-success mx-2"
                        onClick={handleAgree}
                        disabled={
                          messages[messages.length - 1]?.status === "Accepted"
                            ? true
                            : false || isAgreed?.user_accepted
                        }
                      >
                        Agree
                      </button>
                    )}
                  </div>
                  {messages[messages.length - 1]?.is_sanctioned === true && (
                    <span className="badge rounded-pill bg-success mt-1">
                      Your offer has been sanctioned
                    </span>
                  )}
                </div> */}
            {/* </form> */}
            {/* </div> */}
          </div>
        </div>
      </div>
    </main>
  );
}
